<script>
  // @ts-check
  /** Primarily used for testing
   * @type {string}
   * */
  export let id = undefined;

  /** @type {HTMLElement | undefined} */
  export let ref = undefined;

  /** @type { string } */
  export let containerElement = "div";

  /** @type { "regular" | "bleed" } */
  export let variant = "regular";

  /** @type { string } */
  export let containerClass = "";

  /** @type { string } */
  export let gridInnerClasses = "";

  let outsideSpacingClasses = variant === "bleed" ? "" : "px-7.5 lg:px-15";
</script>

<svelte:element this={containerElement} {id} bind:this={ref} class={containerClass}>
  <div
    class="mx-auto h-full w-full max-w-container-content-max {outsideSpacingClasses} {gridInnerClasses}"
  >
    <slot />
  </div>
</svelte:element>
